import React from "react";
import { Chip, makeStyles, Typography, Box } from "@material-ui/core";
import { i18n } from "../../translate/i18n";
import OutlinedDiv from "../OutlinedDiv";
import useColumnAliases from "../../hooks/useColumnAliases";

const useStyles = makeStyles(theme => ({
    chip: {
        margin: theme.spacing(0.25),
        cursor: "pointer",
        height: "24px",
        fontSize: "0.7rem"
    },
    sectionTitle: {
        fontSize: "0.7rem",
        fontWeight: "bold",
        color: theme.palette.text.secondary,
        marginTop: theme.spacing(0.5),
        marginBottom: theme.spacing(0.25),
        textTransform: "uppercase"
    },
    sectionContainer: {
        marginBottom: theme.spacing(0.5)
    },
    chipsContainer: {
        display: "flex",
        flexWrap: "wrap",
        gap: theme.spacing(0.25)
    }
}));

const MessageVariablesPicker = ({ onClick, disabled }) => {
    const classes = useStyles();
    const { getAlias } = useColumnAliases();

    const handleClick = (e, value) => {
        e.preventDefault();
        if (disabled) return;
        onClick(value);
    };

    // Variables del Contacto (datos directos de la lista de contactos)
    const contactVars = [
        {
            name: i18n.t("messageVariablesPicker.vars.contactName"),
            value: "{{name}} "
        },
        {
            name: "Email",
            value: "{{email}} "
        },
        {
            name: "Número",
            value: "{{numero}} "
        },
        {
            name: getAlias("Columna 4"),
            value: "{{colum4}} "
        },
        {
            name: getAlias("Columna 5"),
            value: "{{colum5}} "
        },
        {
            name: getAlias("Columna 6"),
            value: "{{colum6}} "
        },
        {
            name: getAlias("Columna 7"),
            value: "{{colum7}} "
        },
        {
            name: getAlias("Columna 8"),
            value: "{{colum8}} "
        },
        {
            name: getAlias("Columna 9"),
            value: "{{colum9}} "
        },
        {
            name: getAlias("Columna 10"),
            value: "{{colum10}} "
        },
    ];

    // Variables del Sistema (utilidad y transformaciones)
    const systemVars = [
        {
            name: i18n.t("messageVariablesPicker.vars.contactFirstName"),
            value: "{{firstName}}"
        },
        {
            name: i18n.t("messageVariablesPicker.vars.greeting"),
            value: "{{ms}} "
        },
        {
            name: i18n.t("messageVariablesPicker.vars.protocolNumber"),
            value: "{{protocol}} "
        },
        {
            name: i18n.t("messageVariablesPicker.vars.hour"),
            value: "{{hora}} "
        },
    ];

    return (
        <OutlinedDiv
            margin="dense"
            fullWidth
            label={i18n.t("messageVariablesPicker.label")}
            disabled={disabled}
        >
            <Box className={classes.sectionContainer}>
                <Typography className={classes.sectionTitle}>
                    <span role="img" aria-label="Lista de contactos">📋</span> Variables del Contacto
                </Typography>
                <Box className={classes.chipsContainer}>
                    {contactVars.map(msgVar => (
                        <Chip
                            key={msgVar.value}
                            onMouseDown={e => handleClick(e, msgVar.value)}
                            label={msgVar.name}
                            size="small"
                            className={classes.chip}
                            color="primary"
                        />
                    ))}
                </Box>
            </Box>
            <Box className={classes.sectionContainer}>
                <Typography className={classes.sectionTitle}>
                    <span role="img" aria-label="Configuración del sistema">⚙️</span> Variables del Sistema
                </Typography>
                <Box className={classes.chipsContainer}>
                    {systemVars.map(msgVar => (
                        <Chip
                            key={msgVar.value}
                            onMouseDown={e => handleClick(e, msgVar.value)}
                            label={msgVar.name}
                            size="small"
                            className={classes.chip}
                            color="secondary"
                        />
                    ))}
                </Box>
            </Box>
        </OutlinedDiv>
    );
};

export default MessageVariablesPicker;